/**
 * Web feature flags (Create React App: REACT_APP_* at build time).
 *
 * Policy: see apps/plaatplan-web/docs/10-web-feature-flags.md
 * - Mobile app / handoff / pre-release web UI → off by default, gate with these helpers.
 * - Normal product work (i18n, planner, export) → no flag; ship directly.
 */

function readEnvFlag(name) {
  return process.env[name] === "true";
}

/** Umbrella for preview/staging: turns on all gated pre-release web UI. */
export function isWebBetaEnabled() {
  return readEnvFlag("REACT_APP_ENABLE_WEB_BETA");
}

/**
 * QR / deep-link handoff naar de mobile app (Exporteren → Naar werkplaats).
 * Also on when REACT_APP_ENABLE_WEB_BETA=true.
 */
export function isMobileHandoffEnabled() {
  return isWebBetaEnabled() || readEnvFlag("REACT_APP_ENABLE_MOBILE_HANDOFF");
}

/**
 * CTAs and guides that promote the Plaatplan app (planner, werkplan, guides, support modal).
 * Also on when REACT_APP_ENABLE_WEB_BETA=true.
 */
export function isMobileAppPromoEnabled() {
  return isWebBetaEnabled() || readEnvFlag("REACT_APP_ENABLE_MOBILE_APP_PROMO");
}

/**
 * Dismissible app promo on SEO landing pages (/zaagplan-mdf, etc.).
 * Off by default even when REACT_APP_ENABLE_MOBILE_APP_PROMO=true.
 * Also on when REACT_APP_ENABLE_WEB_BETA=true.
 */
export function isMobileAppPromoLandingEnabled() {
  return isWebBetaEnabled() || readEnvFlag("REACT_APP_ENABLE_MOBILE_APP_PROMO_LANDING");
}

/**
 * Template for future gated web features:
 *
 * export function isFooEnabled() {
 *   return isWebBetaEnabled() || readEnvFlag("REACT_APP_ENABLE_FOO");
 * }
 */
